export default __webpack_public_path__ + "static/media/Clients_3.18edd868.svg";